module.exports = __webpack_public_path__ + "img/g_voyage.c8068808.png";